import { createIcon } from '@chakra-ui/react'

export const CheckCircleOutline = createIcon({
  displayName: 'CheckCircleOutline',
  viewBox: '0 0 48 48',
  d: 'M24.0001 0.666016C11.1201 0.666016 0.666748 11.1193 0.666748 23.9993C0.666748 36.8793 11.1201 47.3327 24.0001 47.3327C36.8801 47.3327 47.3334 36.8793 47.3334 23.9993C47.3334 11.1193 36.8801 0.666016 24.0001 0.666016ZM24.0001 42.666C13.7101 42.666 5.33341 34.2893 5.33341 23.9993C5.33341 13.7093 13.7101 5.33268 24.0001 5.33268C34.2901 5.33268 42.6667 13.7093 42.6667 23.9993C42.6667 34.2893 34.2901 42.666 24.0001 42.666ZM34.7101 13.686L19.3334 29.0627L13.2901 23.0427L10.0001 26.3327L19.3334 35.666L38.0001 16.9993L34.7101 13.686Z',
})
